import { render } from "./Text1.vue?vue&type=template&id=760ff8b6"
import script from "./Text1.vue?vue&type=script&lang=ts"
export * from "./Text1.vue?vue&type=script&lang=ts"

import "./Text1.vue?vue&type=style&index=0&id=760ff8b6&lang=scss"
script.render = render

export default script